export default {
    'delete-message': 'هل أنت متأكد من أنك تريد حذف العهد؟',
    'adding-covenant': 'إضافة عهد'
}